export const ENGLISH = 'en';

const state = {
  lang: ENGLISH
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  setLocale({ state, commit }, new_locale) {
    commit('setLocaleState', new_locale);
  }
};

const mutations = {
  setLocaleState(state, locale) {
    state.lang = locale;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
